module.exports = __webpack_public_path__ + "img/studiopro_small.ba3b1dc1.png";